import classnames from 'classnames';

import { Score, SingleScoreIconProps } from 'fable/ScoreIcon/types';

import style from '../../index.module.scss';

import NumberSelected1 from './svg/number-1-selected.svg';
import Number1 from './svg/number-1.svg';
import NumberSelected2 from './svg/number-2-selected.svg';
import Number2 from './svg/number-2.svg';
import NumberSelected3 from './svg/number-3-selected.svg';
import Number3 from './svg/number-3.svg';
import NumberSelected4 from './svg/number-4-selected.svg';
import Number4 from './svg/number-4.svg';
import NumberSelected5 from './svg/number-5-selected.svg';
import Number5 from './svg/number-5.svg';

const ratings: Record<Score, Record<'unselected' | 'selected', string>> = {
  1: { unselected: Number1, selected: NumberSelected1 },
  2: { unselected: Number2, selected: NumberSelected2 },
  3: { unselected: Number3, selected: NumberSelected3 },
  4: { unselected: Number4, selected: NumberSelected4 },
  5: { unselected: Number5, selected: NumberSelected5 },
};

export const Number = ({
  score,
  isSelected,
  size,
}: SingleScoreIconProps): JSX.Element => {
  const { unselected, selected } = ratings[score];

  return (
    <img
      src={isSelected ? selected : unselected}
      alt={score.toString()}
      style={{ width: size, height: size }}
      className={classnames(style.numberIcon, { [style.selected]: isSelected })}
    />
  );
};
